import { attr, belongsTo } from '@ember-data/model';
import BaseModel, { type IResourceName } from 'volta/models/base-model';
import { Type } from '@warp-drive/core-types/symbols';
import type AppFeature from './app-feature';

export const TenantResourceName: IResourceName = {
  singular: 'tenant',
  plural: 'tenants'
};

/**
 * @class Tenant model
 * @extends BaseModel
 */
export default class Tenant extends BaseModel {
  @attr('string')
  declare tenantId: string;

  @attr('string')
  declare env: string;

  @attr('array', { defaultValue: () => [] })
  declare authorizedProviders: string[];

  @belongsTo('app-feature', { async: false, inverse: null })
  declare features: AppFeature;

  [Type] = 'tenant' as const;
}
